export default {
    deleteViewersSuccessMsg: "Viewer deleted successfully",
    deleteViewersFailedMsg: "Deleting viewer failed",
  };